import { Component, ViewEncapsulation } from "@angular/core";
import { Store } from "@ngrx/store";
import { AppState, stateGetter } from "src/app/store/state/app.state";
import { ChangeDateFilter } from "src/app/store/actions/research-grid-page.actions";
import * as dayjs from "dayjs";
import { VAIconRegistryService, redo } from "@va/core-library/icons";

@Component({
  selector: "app-date-filter",
  templateUrl: "./date-filter.component.html",
  styleUrls: ["./date-filter.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class DateFilterComponent {
  visible = false;
  radioValue = "";
  lblVal = "";
  startDate = "";
  endDate = "";
  customStartDate = null;
  customEndDate = null;
  lastAppliedFilterObject = {};
  popoverOpen = false;
  validDate = true;
  options = [
    { label: "Yesterday", value: "yesterday" },
    { label: "Last 30 Days", value: "oneMonth" },
    { label: "Last 3 Months", value: "threeMonths" },
    { label: "Last 6 Months", value: "sixMonths" },
    { label: "Last 12 Months", value: "twelveMonths" },
  ];
  constructor(
    private store: Store<AppState>,
    private iconRegistry: VAIconRegistryService,
  ) {
    store
      .select(stateGetter("researchBaseObj", "gridFilters", "date"))
      .subscribe((data) => {
        if (data) {
          this.lastAppliedFilterObject = data;
          if (data.startDate === "" && data.endDate === "") {
            this.lblVal = "";
            this.radioValue = "";
          }
        }
      });
    this.iconRegistry.registerIcons([redo]);
  }

  optionSelected() {
    // console.log(`Selected Value: ${this.radioValue}`);
    let payload = {};
    switch (this.radioValue) {
      case "yesterday":
        this.validDate = true;
        this.customStartDate = null;
        this.customEndDate = null;
        this.startDate = dayjs().subtract(1, "day").format("YYYY-MM-DD");
        this.endDate = this.startDate;
        payload = {
          ...this.lastAppliedFilterObject,
          startDate: this.startDate,
          endDate: this.endDate,
          radioValue: this.radioValue,
        };
        this.store.dispatch(new ChangeDateFilter(payload));
        break;
      case "oneMonth":
        this.validDate = true;
        this.customStartDate = null;
        this.customEndDate = null;
        this.startDate = dayjs().subtract(30, "day").format("YYYY-MM-DD");
        this.endDate = dayjs().format("YYYY-MM-DD");
        payload = {
          ...this.lastAppliedFilterObject,
          startDate: this.startDate,
          endDate: this.endDate,
        };
        this.store.dispatch(new ChangeDateFilter(payload));
        break;
      case "threeMonths":
        this.validDate = true;
        this.customStartDate = null;
        this.customEndDate = null;
        this.startDate = dayjs().subtract(3, "month").format("YYYY-MM-DD");
        this.endDate = dayjs().format("YYYY-MM-DD");
        payload = {
          ...this.lastAppliedFilterObject,
          startDate: this.startDate,
          endDate: this.endDate,
        };
        this.store.dispatch(new ChangeDateFilter(payload));
        break;
      case "sixMonths":
        this.validDate = true;
        this.customStartDate = null;
        this.customEndDate = null;
        this.startDate = dayjs().subtract(6, "month").format("YYYY-MM-DD");
        this.endDate = dayjs().format("YYYY-MM-DD");
        payload = {
          ...this.lastAppliedFilterObject,
          startDate: this.startDate,
          endDate: this.endDate,
        };
        this.store.dispatch(new ChangeDateFilter(payload));
        break;
      case "twelveMonths":
        this.validDate = true;
        this.customStartDate = null;
        this.customEndDate = null;
        this.startDate = dayjs().subtract(12, "month").format("YYYY-MM-DD");
        this.endDate = dayjs().format("YYYY-MM-DD");
        payload = {
          ...this.lastAppliedFilterObject,
          startDate: this.startDate,
          endDate: this.endDate,
        };
        this.store.dispatch(new ChangeDateFilter(payload));
        break;
      case "choose":
        this.startDate = this.customStartDate || "";
        this.endDate = this.customEndDate || "";
        this.lblVal = `${dayjs(this.startDate).format("DD/MM/YYYY")} - ${dayjs(
          this.endDate,
        ).format("DD/MM/YYYY")}`;
        // console.log(` After --- startdate: ${this.customStartDate}  enddate : ${this.endDate}`);

        // console.log(` false : ${dayjs(this.endDate).isAfter(this.startDate, 'day')}`);
        // this.validDate = dayjs(this.endDate).isAfter(this.startDate, 'day');

        if (this.startDate !== "" && this.endDate !== "") {
          this.validDate = true;
          payload = {
            ...this.lastAppliedFilterObject,
            startDate: dayjs(this.startDate).format("YYYY-MM-DD"),
            endDate: dayjs(this.endDate).format("YYYY-MM-DD"),
          };
          this.store.dispatch(new ChangeDateFilter(payload));
        } else {
          this.validDate = false;
        }
        break;
      default:
        //console.log("default");
        this.startDate = "";
        this.endDate = "";
        payload = {
          ...this.lastAppliedFilterObject,
          startDate: this.startDate,
          endDate: this.endDate,
        };
        this.store.dispatch(new ChangeDateFilter(payload));
    }
  }

  startDateChange(date: Date): void {
    this.customStartDate = date;
  }

  endDateChange(date: Date): void {
    this.customEndDate = date;
  }

  disabledStartDate = (startValue: Date): boolean => {
    if (!startValue || !this.customEndDate) {
      return false;
    }
    return startValue.getTime() > this.customEndDate.getTime();
  };

  disabledEndDate = (endValue: Date): boolean => {
    if (!endValue || !this.customStartDate) {
      return false;
    }
    return endValue.getTime() < this.customStartDate.getTime();
  };

  reset() {
    if (this.radioValue !== "") {
      this.radioValue = "";
      this.lblVal = "";
      this.optionSelected();
    }
    this.customStartDate = null;
    this.customEndDate = null;
  }

  popoverChange() {
    this.popoverOpen = !this.popoverOpen;
    if (this.popoverOpen === false && this.radioValue !== "") {
      //setting label value
      if (this.radioValue !== "choose") {
        const index = this.options.findIndex(
          (x) => x.value === this.radioValue,
        );
        this.lblVal = this.options[index].label;
      }

      this.optionSelected();
    }
  }
}
